import { createHashHistory } from 'history';

const history = createHashHistory();
history.listen((location, action) => {
    window.scrollTo(0, 0)
})
export default history;